import React, { useState } from "react";

import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { hasAuthHint } from "../utils/authHint";
import AuthLoadingScreen from "./AuthLoadingScreen";

export default function AuthRouteUser({ children }) {
  const { currentUser, authState } = useAuth();
  // Read once on mount so the guard's decision is stable for this visit.
  const [likelySignedIn] = useState(hasAuthHint);

  if (authState?.status === "pending") {
    // A visitor this browser has never signed in doesn't need to wait out the
    // auth check (or a Cloud Run cold start) to learn they must log in — send
    // them to /login now. If they actually do hold a valid session cookie
    // (hint cleared, different install), the login guard bounces them back to
    // the dashboard as soon as the pending check resolves.
    if (!likelySignedIn) {
      return <Navigate to="/login" replace />;
    }

    // Probably signed in: the wait is unavoidable (we can't render protected
    // content unverified), but explain it instead of spinning silently.
    return <AuthLoadingScreen />;
  }

  if (!currentUser) {
    // Redirect to login if not authenticated
    return <Navigate to="/login" replace />;
  }

  return children;
}
